import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export interface InternalLinkSuggestion {
  keyword: string;
  title: string;
  url: string;
  relevance: number;
}

export interface ImageSuggestion {
  url: string;
  alt: string;
  caption: string;
  position: number;
  section: string;
}

export interface SEOImprovement {
  type: string;
  priority: 'high' | 'medium' | 'low';
  message: string;
  suggestion: string;
}

export interface SEOSuggestionsResponse {
  success: boolean;
  data: {
    internalLinks: InternalLinkSuggestion[];
    imageSuggestions: ImageSuggestion[];
    improvements: SEOImprovement[];
  };
  error?: string;
}

export class SEOService {
  /**
   * SEO 제안 가져오기
   */
  async getSuggestions(
    keyword: string,
    content: string,
    metadata: any = {}
  ): Promise<SEOSuggestionsResponse['data']> {
    try {
      const response = await apiClient.post<SEOSuggestionsResponse>(
        '/v2/seo/suggestions',
        {
          keyword,
          content,
          metadata,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.error || 'SEO 제안을 가져오는데 실패했습니다.');
      }

      return response.data.data;
    } catch (error: any) {
      console.error('SEO suggestions error:', error);
      throw new Error(error.response?.data?.error || 'SEO 제안을 가져오는데 실패했습니다.');
    }
  }
}

export const seoService = new SEOService();

